import { log } from "../utils/log_utils";
import apiClient from "../utils/api_client";

export async function addResumeComment(resumeId, content, token='') {
    try {
        console.log({ resumeId, content })
        return await apiClient('/resume/comments/add',{
            method: 'POST',
            credentials: "include",
            body: JSON.stringify({
                resumeId,
                token,
                content
            })
        })
    } catch (error) {
        log("add comment failed", error,"addResumeComment")
        return { success: false, error: "something went wrong"}
    }
    
}


